import { FOCUS_RING_CLASS } from '../../../constants/focus-ring-class'

/** Above the toolbar root's own `zIndex: 9999`, so a popover can never be occluded by the pill. */
export const POPOVER_CLASS = 'z-[10000]'

/**
 * Every control in the pill reads the same, at the Figma action bar's metrics
 * (node 20416:459700): a 32px-tall borderless button, 12px horizontal padding, 8px icon gap,
 * `text-xs`/500 in `--foreground`.
 *
 * Borderless on purpose — the two segmented group boxes in `text-on-path-toolbar.tsx` supply the
 * `border-input` box and the seam rules. A grouped control passes `h-full rounded-none` through
 * `className` so it fills the group's 32px border-box without rounding its own corners on hover;
 * a standalone one (the colour swatch) keeps the `rounded-md` here.
 */
export const TRIGGER_CLASS = `flex h-8 flex-shrink-0 cursor-pointer items-center gap-2 rounded-md border-none bg-transparent px-3 text-xs font-medium text-foreground transition-colors hover:bg-accent disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent ${FOCUS_RING_CLASS}`
